import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: pxToRem(16),
    fontWeight: 400,
  },
  saveDraftButton: {
    marginRight: pxToRem(16),
  },
  moduleHeaderText: {
    ...theme.fonts.large,
    selectors: {
      [layout.breakpoints.min.md]: {
        ...theme.fonts.xLarge,
      },
    },
  },
  messageBar: {
    marginBottom: pxToRem(20),
    color: theme.palette.neutralDark,
    selectors: {
      '.ms-MessageBar-icon i': {
        color: theme.palette.neutralDark,
      },
    },
  },
  thisIsADraftMessageTitle: {
    color: theme.palette.neutralDark,
  },
  thisIsADraftMessage: {
    color: theme.palette.neutralDark,
    fontWeight: 400,
  },
  transparentBackground: {
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent',
    },
  },
  negativeAmount: {
    color: theme.palette.accentError,
  },
  dimText: {
    opacity: 0.5,
  },
  hidden: {
    visibility: 'hidden',
  },
  submitButton: {
    marginLeft: pxToRem(20),
  },
  discardReversalLoadingSpinner: {
    marginLeft: pxToRem(20),
  },
  textColorError: {
    color: theme.palette.accentError,
  },
  fluentRow: {
    marginBottom: `${pxToRem(20)} !important`,
  },
  paymentStatusSentIcon: {
    paddingTop: pxToRem(100),
    marginRight: pxToRem(10),
    color: theme.palette.accentTeal,
  },
  paymentStatusInProgressIcon: {
    paddingTop: pxToRem(50),
    marginRight: pxToRem(10),
    color: theme.palette.accentYellow,
  },
  paymentStatusDate: {
    fontWeight: `300 !important`,
    color: `${theme.palette.neutralSecondary} !important`,
    marginRight: pxToRem(10),
  },
  paymentDetailsButton: {
    color: theme.palette.themePrimary,
    textDecoration: 'underline',
    cursor: 'text',
  },
});
